import { getEpgMenu } from 'containers/User/service';
import m from 'moment';
import {
  FETCH_EPG_MENU_ERROR,
  FETCH_EPG_MENU_SUCCESS,
  FETCH_EPG_MENU_INIT,
} from './constants';

export const fetchEpgMenu= (params = {}) => (dispatch, getState) => {

  
    const state = getState();

    dispatch({ type: FETCH_EPG_MENU_INIT });
  
    setTimeout(() => dispatch(fetchEpgMenu(params)), 6 * 3600 * 1000);

    return getEpgMenu({
        params,
      
    })
      .then(data => {
        if (data.response) {
          dispatch({
            type: FETCH_EPG_MENU_SUCCESS,
            payload: data.response,
          });
        } else {
          console.log('error epg 1')
  
          dispatch({
            type: FETCH_EPG_MENU_ERROR,
            error: new Error(data.errors.code),
          });
        }
      })
      .catch(error => {
        console.log('error epg')
        dispatch({
          type: FETCH_EPG_MENU_ERROR,
          error,
        });
      });
  };